/////////////////////////////////////////////////////////////////////////////
//////////////////////  LAZYLOADING IMAGES SCRIPT //////////////////////////
///////////////////////////////////////////////////////////////////////////

// Function to swap "large" quality image with high-quality "master" images

// for large pages use this code as such

// <!-- Above the Fold (No lazy loading) -->
// <img src="banner1-image1.jpg" alt="First Banner Image" fetchpriority="high" />

// <!-- Just Below the Fold (Use custom lazyload class, but no fetchpriority low) -->
// <img src="banner2-image1.jpg" data-src="banner2-high-quality-image1.jpg" alt="Second Banner Image" class="lazyload" loading="lazy" />

// <!-- Far Below the Fold (Use native lazy loading with fetchpriority low) -->
// <img src="banner3-image1.jpg" loading="lazy" fetchpriority="low" alt="Third Banner Image" />

document.addEventListener("DOMContentLoaded", function () {
  const lazyImages = document.querySelectorAll(".lazyload");

  // Function to preload and swap image
  function preloadImage(img) {
    const highQualitySrc = img.dataset.src;
    if (!highQualitySrc) return;

    const highQualityImage = new Image();
    highQualityImage.src = highQualitySrc;

    highQualityImage.onload = function () {
      highQualityImage
        .decode()
        .then(() => {
          img.src = highQualitySrc; // Seamlessly replace with high-quality image
          img.classList.remove("lazyload"); // Optionally remove the lazyload class
        })
        .catch((err) => {
          console.error("Failed to decode image:", err); // Handle decode errors
        });
    };

    highQualityImage.onerror = function () {
      console.error("Failed to load high-quality image:", highQualitySrc);
      // Optionally add fallback behavior here if the high-quality image fails
    };
  }

  // Set up the intersection observer to trigger the image swap
  const observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const img = entry.target;
          preloadImage(img); // Trigger image swap immediately when in view
          observer.unobserve(img); // Stop observing once the swap is done
        }
      });
    },
    {
      root: null, // Observe in relation to the viewport
      rootMargin: "100px", // Start swapping 100px before the image comes into view
      threshold: 0, // Trigger as soon as any part of the image is visible
    }
  );

  // Observe each lazy-loaded image
  lazyImages.forEach(function (img) {
    observer.observe(img);
  });
});

/////////////////////////////////////////////////////////////////////////////
///////////////////  RATTLING CARDS, TITLES AND BANNERS JS /////////////////
///////////////////////////////////////////////////////////////////////////

// Use class .rattle on any element for this to apply, see application.css

document.addEventListener("DOMContentLoaded", () => {
  const rattles = document.querySelectorAll(".rattle");

  const observerOptions = {
    root: null, // Use the viewport as the container
    rootMargin: "0px",
    threshold: 0.1, // Trigger when 10% of the element is visible
  };

  const observerCallback = (entries, observer) => {
    let delayOffset = 0; // Base delay for domino effect
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        // Add 'rattled' class with a slight delay
        setTimeout(() => {
          entry.target.classList.add("rattled");
        }, delayOffset);

        delayOffset += 150; // Slight delay for the domino effect
        observer.unobserve(entry.target); // Stop observing once animated
      }
    });
  };

  const observer = new IntersectionObserver(observerCallback, observerOptions);

  rattles.forEach((rattle) => observer.observe(rattle));
});

/////////////////////////////////////////////////////////////////////////////
///////////////  DISABLING FOCUS VISIBLE OUTLINE IN MOBILE  ////////////////
///////////////////////////////////////////////////////////////////////////

document.addEventListener("DOMContentLoaded", () => {
  let isTouch = false;
  let debounceTimeout;

  document.addEventListener("touchstart", () => {
    clearTimeout(debounceTimeout);
    debounceTimeout = setTimeout(() => {
      isTouch = true;
      document.body.classList.add("disable-focus-visible");
    }, 50); // Debounce by 50ms
  });

  document.addEventListener("keydown", () => {
    clearTimeout(debounceTimeout);
    debounceTimeout = setTimeout(() => {
      isTouch = false;
      document.body.classList.remove("disable-focus-visible");
    }, 50);
  });
});

/////////////////////////////////////////////////////////////////////////////
//////////  OVERRIDING THE COOKIE BANNER PRIVACY POLICY LINK  //////////////
///////////////////////////////////////////////////////////////////////////


  document.addEventListener("DOMContentLoaded", function () {
    const maxAttempts = 50; // ~5 seconds if interval is 100ms
    let attempts = 0;

    const interval = setInterval(() => {
      const policyLink = document.getElementById("shopify-pc__banner__body-policy-link");

      if (policyLink && policyLink.href === "https://www.okkerockers.com/policies/privacy-policy") {
        policyLink.href = "/pages/policies";
        clearInterval(interval);
        console.log("Cookie banner - policy link updated");
      }

      if (++attempts > maxAttempts) {
        clearInterval(interval);
        console.log("Cookie banner - policy link check stopped (max attempts reached)");
      }
    }, 100);
  });
